// 问卷调查
export const SURVEY_TEMPLATE = "/api/survey/getSurveyTemplate";
export const SURVEY_CLOSE = "/api/survey/close";
export const SURVEY_STATUS = "/api/survey/getStatus";
export const SURVEY_ADD = "/api/survey/add";

// 站内信
/** 未读数量 */
export const NOTICE_UNREAD_NUM = "/api/notice/unReadNum";
/** 全部已读 */
export const NOTICE_ALL_READ = "/api/notice/allRead";
/** 站内信列表 */
export const NOTICE_PAGE_LIST = "/api/notice/pageList";
/** 站内信删除 */
export const NOTICE_DELETE = "/api/notice/delete";

// 客服二维码
export const GET_LARK_QR = "/api/base/larkQR";
